import apiClient from '@src/services/apiClient'
import { initDataPath } from '@hkpca-web/config/apiPaths'

export const fetchInitData = () => {
  return apiClient.get(
    initDataPath,
    {}
  )
}
